module.exports = __webpack_public_path__ + "assets/img/invitation.9cff4815.png";